var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Создание шаблона сообщения")]),_c('div',[_c('mail-form',{on:{"onSubmit":_vm.submit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }